"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtrlKey = void 0;
var get_platform_1 = require("../functions/get-platform");
var isCtrlKey = function (keyEvent) {
    var os = (0, get_platform_1.getPlatform)();
    switch (os) {
        case 'mac':
            return keyEvent.metaKey;
        case 'windows':
            return keyEvent.ctrlKey;
        default:
            return keyEvent.ctrlKey;
    }
};
exports.isCtrlKey = isCtrlKey;
